<template>
  <v-container fluid>
    <v-card class="pa-6" rounded="lg">
      <form @submit.prevent="save">
        <v-row align="center" v-if="student">
          <v-col cols="12" md="6" lg="4">
            <label class="font-weight-medium body-2">Student name</label>
            <v-text-field class="my-0 py-1" placeholder="Student name" disabled
              v-model="student.studentEnrollment.studentName"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <label class="font-weight-medium body-2">Class</label>
            <v-text-field placeholder="Class" class="my-0 py-1" disabled v-model="student.class">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6" lg="4">
            <label class="font-weight-medium body-2">Section</label>
            <v-text-field placeholder="Section" class="my-0 py-1" disabled
              v-model="student.section"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" lg="4">
            <label class="font-weight-medium body-2">Term</label>
            <v-autocomplete class="my-0 py-1" v-model="selectedTerm" :items="terms"
              item-text="customName" item-value="id" placeholder="Term"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row> </v-row>
      </form>
      <v-btn @click="printInvoice()" elevation="1" outlined :disabled="!reportData">
        <v-icon left>mdi-printer</v-icon>Print
      </v-btn>
    </v-card>
    <!-- <ReportCard :reportData="tableData" :studentData="student" :otherData="allData"></ReportCard> -->
    <iframe id="iframeReceipt" name="iframeReceipt" style="height:0;width:0;"></iframe>
    <div v-if="reportData">
      <v-card flat rounded="lg" class="mt-5" v-if="gradeMaps.length" id="section-to-print">
        <div>

          <table id="printableArea1" width="100%" border="0" align="center" cellpadding="0"
            cellspacing="0" style="position: relative;">
            <tr>
              <td align="center" valign="top" bgcolor="#FFFFFF">
                <table width="700" border="0" cellspacing="0" cellpadding="0">
                  <img @load="onLoadAll"
                    src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardAbout.png"
                    alt="" />
                  <tbody>
                    <tr>
                      <td align="center" valign="top" style="position: absolute;
    top: 254px;
    width: 190px;
    left: 0px;
    right: 0px;
    margin: auto;">
                        <div style="position: relative;
}">
                          <img @load="onLoadAll" style="    position: absolute;
    left: 0;
    right: 0;
    margin: auto;" src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardBorder.png"
                            alt="" />
                          <img @load="onLoadAll"
                            :src="studentPhoto ? studentPhoto : 'http://cdn.fcglcdn.com/brainbees//intelli/intellitots/images/Reportcard_Page1_03.jpg'"
                            style="    position: absolute;
    left: 0px;
    right: 0px;
    margin: auto;
    width: 164px;
    height: 212px;
    top: 15px;" alt="studentPhoto" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" valign="top" style="    position: absolute;
    top: 550px;
    width: 380px;
    left: 0px;
    right: 0px;
    margin: auto;">
                        <img @load="onLoadAll"
                          src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardABOUTYOURSELF.png"
                          style="" alt="studentPhoto" />
                      </td>
                    </tr>
                    <tr>
                      <td align="center" valign="top">
                        <table border="0" cellspacing="0" cellpadding="0">
                          <tr>
                            <td align="left" valign="top" style="position: absolute;
    top: 640px;
    left: 0px;
    right: 0px;
    margin: auto;
    width: 390px;">
                              <span
                                style="font-size: 20px;font-family: sans-serif; font-weight:600; line-height: 2.0em;">My
                                Name: <span
                                  style="font-size: 20px;font-weight: 400; ">{{ student.studentEnrollment.studentName }}</span><br />
                                My Grade: <span
                                  style="font-size: 20px;font-weight: 400; ">{{ student.class }} >>
                                  {{ student.section }}</span><br />
                                My Teacher: <span
                                  style="font-size: 20px;font-weight: 400; ">{{ studentRemarks[0].teacherName }}</span><br />
                                My Birthday is on: <span
                                  style="font-size:20px; font-weight: 400; ">{{ student.studentEnrollment.dateOfBirth }}</span><br />
                                I Joined Playschool on:
                                <span
                                  style="font-size: 20px;font-weight: 400; ">{{ student.studentEnrollment.dateOfAdmission }}</span>
                              </span>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td align="center" valign="bottom">
                        <p id="pageCount">1</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </table>

          <div class="report-card">
            <table id="printableArea2" width="100%" border="0" align="center" cellpadding="0"
              cellspacing="0">
              <tr>
                <td align="center" valign="top" bgcolor="#FFFFFF"
                  style="padding:20px 10px 20px 10px;">
                  <table width="700" border="0" cellspacing="0" cellpadding="0">
                    <tr>
                      <td class="v-align-top" align="center" valign="top" bgcolor="#FFFFFF">
                        <table width="700" border="0" cellspacing="0" cellpadding="0">
                          <tbody>
                            <tr>
                              <td align="left" valign="top">
                                <table class="" width="700" border="0" cellspacing="0"
                                  cellpadding="0">
                                  <tbody>
                                    <tr>
                                      <td align="left" valign="top">
                                        <img @load="onLoadAll"
                                          src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardHeader.png"
                                          alt="Intellitots" title="Intellitots" width="700"
                                          height="155" border="0" style="display:block;" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <h1 class="reportCardtitle">
                                          Passport Assessment Criteria And Description
                                        </h1>
                                      </td>
                                    </tr>
                                    <tr>
                                      <table class="criteriaAndDescription bordered-table">
                                        <thead>
                                          <tr>
                                            <th class="bordered-bottom"
                                              style="width:26%;padding-left: 40px;">Criteria</th>
                                            <th class="bordered-bottom" style="text-align:center;">
                                              Description</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td class="first-column bordered-bottom"
                                              style="width:26%;padding-left: 40px;">
                                              Emerging
                                            </td>
                                            <td class="bordered-bottom" style="text-align:left;">
                                              The child is making progress towards meeting few of
                                              the learning outcomes addressed during the current
                                              reporting period. He/she demonstrates limited
                                              achievement in few of the expected areas of knowledge,
                                              concepts, skills or attitude. The child makes errors
                                              while performing tasks and requires more time,
                                              practice and support of the teacher.
                                            </td>
                                          </tr>
                                          <tr>
                                            <td class="first-column bordered-bottom"
                                              style="width:26%;padding-left: 40px;">
                                              Developing
                                            </td>
                                            <td style="text-align:left;" class="bordered-bottom">
                                              The child is meeting some of the learning outcomes
                                              addressed during the current reporting period. He/she
                                              demonstrates satisfactory achievement in some of
                                              the expected areas of knowledge, concepts, skills or
                                              attitudes. The child makes some errors while
                                              performing tasks and requires more time and practice.
                                            </td>
                                          </tr>

                                          <tr>
                                            <td class="first-column bordered-bottom"
                                              style="width:26%;padding-left: 40px;">
                                              Mastering
                                            </td>
                                            <td style="text-align:left;" class="bordered-bottom">
                                              The child is meeting most of the learning outcomes
                                              addressed during the current reporting period. He/she
                                              demonstrates good achievement and limited mastery
                                              in most of the expected areas of knowledge, concepts,
                                              skills or attitudes. The child makes very few errors
                                              while performing tasks and could improve with
                                              practice.
                                            </td>
                                          </tr>

                                          <tr>
                                            <td class="first-column"
                                              style="width:26%;padding-left: 40px;">
                                              Proficient
                                            </td>
                                            <td style="text-align:left;" class="bordered-bottom">
                                              The child is meeting all the learning outcomes
                                              addressed during the current reporting period. He/she
                                              demonstrates exceptional achievement and mastery in
                                              all the expected areas of knowledge, concepts, skills
                                              or attitudes. The child makes no errors and regularly
                                              produces high quality work.
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </tr>

                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td align="center" valign="top">
                                <p id="page" style="margin-bottom:0; margin-top:50px">2</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
          <div class="report-card">
            <table class="loopInPrint" v-for="(items, i) in tableData" :key="i" width="100%"
              border="0" align="center" cellpadding="0" cellspacing="0">
              <tr>
                <td align="center" valign="top" bgcolor="#FFFFFF"
                  style="padding:20px 10px 20px 10px;">
                  <table width="700" border="0" cellspacing="0" cellpadding="0">
                    <tr>
                      <td class="v-align-top" align="center" valign="top" bgcolor="#FFFFFF">
                        <table width="700" border="0" cellspacing="0" cellpadding="0">
                          <tbody>
                            <tr>
                              <td align="left" valign="top">
                                <table width="700" border="0" cellspacing="0" cellpadding="0">
                                  <tbody>
                                    <tr>
                                      <td align="center" valign="top">
                                        <table width="700" border="0" cellspacing="0"
                                          cellpadding="0">
                                          <tbody>
                                            <tr>
                                              <td align="left" valign="top">
                                                <img @load="onLoadAll"
                                                  src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardHeader.png"
                                                  alt="Intellitots" width="700" height="100"
                                                  title="Intellitots" border="0"
                                                  style="display:block;" />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>

                                        <!--Term heading start-->
                                        <div v-for="(item, x) in terms" :key="x">
                                          <div v-if="item.id === selectedTerm">
                                            <table width="700" border="0" cellspacing="0"
                                              cellpadding="0">
                                              <tbody>
                                                <tr>
                                                  <td align="center" valign="top">
                                                    <img @load="onLoadAll"
                                                      :src="termIconHandler(item.academicTermID)"
                                                      alt="Intellitots" width="100" height="30"
                                                      title="Intellitots" border="0"
                                                      style="display:block;" />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                        <!-- <div v-if="terms[0].id === selectedTerm">
                                          <table width="700" border="0" cellspacing="0"
                                            cellpadding="0" v-if="i === 0">
                                            <tbody>
                                              <tr>
                                                <td align="center" valign="top">
                                                  <img @load="onLoadAll"
                                                    src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardterm-1.png"
                                                    alt="Intellitots" width="100" height="30"
                                                    title="Intellitots" border="0"
                                                    style="display:block;" />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <div v-if="terms[1].id === selectedTerm">
                                          <table width="700" border="0" cellspacing="0"
                                            cellpadding="0" v-if="i === 0">
                                            <tbody>
                                              <tr>
                                                <td align="center" valign="top">
                                                  <img @load="onLoadAll"
                                                    src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardterm-2.png"
                                                    alt="Intellitots" width="100" height="30"
                                                    title="Intellitots" border="0"
                                                    style="display:block;" />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <div v-if="terms[2].id === selectedTerm">
                                          <table width="700" border="0" cellspacing="0"
                                            cellpadding="0" v-if="i === 0">
                                            <tbody>
                                              <tr>
                                                <td align="center" valign="top">
                                                  <img @load="onLoadAll"
                                                    src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardterm-3.png"
                                                    alt="Intellitots" width="100" height="30"
                                                    title="Intellitots" border="0"
                                                    style="display:block;" />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div> -->
                                        <!--Term heading end-->
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>
                                        <h1 class="reportCardtitle" style="margin-top:25px">
                                          {{ items.parameters[0].gradeSkill.name }}
                                        </h1>
                                      </td>
                                    </tr>
                                    <tr>
                                      <table style="width:100%;" class=" bordered-table">
                                        <thead>
                                          <tr>
                                            <th class="bordered-bottom border-right">
                                              {{ heads[i][0].text }}</th>
                                            <th class="bordered-bottom border-right"
                                              style="text-align:center;">{{ heads[i][1].text }}</th>
                                            <th class="bordered-bottom border-right"
                                              style="text-align:center;">{{ heads[i][2].text }}</th>
                                            <th class="bordered-bottom border-right"
                                              style="text-align:center;">{{ heads[i][3].text }}</th>
                                            <th class="bordered-bottom border-right"
                                              style="text-align:center;">{{ heads[i][4].text }}</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(item, x) in items.parameters" :key="x">
                                            <td class="first-column bordered-bottom border-right">
                                              {{ item.gradeParameter.name }}
                                            </td>
                                            <td class="bordered-bottom border-right" style=""
                                              align="center">
                                              <div v-if=" item.isEmerging" class="">
                                                <img @load="onLoadAll"
                                                  src="http://cdn.fcglcdn.com/brainbees//intelli/intellitots/images/right.png"
                                                  alt="" width="30" />
                                              </div>
                                            </td>
                                            <td class="bordered-bottom border-right" align="center">
                                              <div v-if="item.isStandard" class="">
                                                <img @load="onLoadAll"
                                                  src="http://cdn.fcglcdn.com/brainbees//intelli/intellitots/images/right.png"
                                                  alt="" width="30" />
                                              </div>
                                            </td>
                                            <td class="bordered-bottom border-right" align="center">
                                              <div v-if="item.isProficient" class="">
                                                <img @load="onLoadAll"
                                                  src="http://cdn.fcglcdn.com/brainbees//intelli/intellitots/images/right.png"
                                                  alt="" width="30" />
                                              </div>
                                            </td>
                                            <td class="bordered-bottom border-right" align="center">
                                              <div v-if="item.isAdvance" class="">
                                                <img @load="onLoadAll"
                                                  src="http://cdn.fcglcdn.com/brainbees//intelli/intellitots/images/right.png"
                                                  alt="" width="30" />
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </tr>
                                    <tr></tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>

                          </tbody>
                          <tfoot id="footer">
                            <tr>
                              <td align="center" valign="bottom">

                                <p id="page" style="margin-bottom:0; margin-top:50px;">{{i+3}}</p>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <th align="center" valign="top" bgcolor="#FFFFFF" scope="col"></th>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>

          <table id="printableAreaEnd1" width="100%" border="0" align="center" cellpadding="0"
            cellspacing="0">
            <tr>
              <td align="center" valign="top" bgcolor="#FFFFFF"
                style="padding:20px 10px 20px 10px;">
                <table width="700" border="0" cellspacing="0" cellpadding="0">
                  <tr>
                    <td align="center" valign="top" bgcolor="#FFFFFF">
                      <table width="700" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td align="center" valign="top">
                              <table width="700" border="0" cellspacing="0" cellpadding="0">
                                <tbody>
                                  <tr>
                                    <td align="left" valign="top">
                                      <img @load="onLoadAll"
                                        src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardHeader.png"
                                        alt="Intellitots" title="Intellitots" width="700"
                                        height="158" border="0" style="display:block;" />
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>
                                      <h1 class="reportCardtitle">
                                        Attendance details
                                      </h1>
                                    </td>
                                  </tr>
                                  <tr>
                                    <table style="width:100%;" class=" bordered-table">
                                      <tbody>
                                        <tr>
                                          <td class="first-column bordered-bottom border-right">
                                            <span style="font-weight:600"> Term duration</span>
                                          </td>
                                          <td class="bordered-bottom">
                                            {{termDuration}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="first-column bordered-bottom border-right">
                                            <span style="font-weight:600"> No. of days
                                              present</span>
                                          </td>
                                          <td class="bordered-bottom">
                                            <span>{{noOfDaysPresent ?noOfDaysPresent: '--' }}</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="first-column bordered-bottom border-right">
                                            <span style="font-weight:600"> Percentage
                                              attendance</span>
                                          </td>
                                          <td class="bordered-bottom">
                                            <span>{{noOfDaysPresentPercent ? noOfDaysPresentPercent: '--'}}</span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td align="center" valign="top">
                              <p id="page" style="margin-top:300px; margin-bottom:0;">
                                {{lastvalue -1 }}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <table id="printableAreaEnd2" width="100%" border="0" align="center" cellpadding="0"
            cellspacing="0">
            <tr>
              <td align="center" valign="top" bgcolor="#FFFFFF"
                style="padding:20px 10px 20px 10px;">
                <table width="700" border="0" cellspacing="0" cellpadding="0">
                  <tr>
                    <td align="center" valign="top" bgcolor="#FFFFFF">
                      <table width="700" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <td align="center" valign="top">
                              <table width="700" border="0" cellspacing="0" cellpadding="0">
                                <tbody>
                                  <tr style=" margin-top:10px;">
                                    <td align="left" valign="top" class="v-align-top">
                                      <img @load="onLoadAll"
                                        src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardHeader.png"
                                        alt="Intellitots" title="Intellitots" width="700"
                                        height="158" border="0" style="display:block;" />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td align="left" valign="top">
                                      <table width="700" border="0" cellspacing="0" cellpadding="0">

                                        <tr>
                                          <td align="center" valign="top">
                                            <table style="border-collapse: collapse;
    border-radius: 30px;
    border-style: hidden;
    box-shadow: 0 0 0 1px #5f3892;" width="600" border="0" cellspacing="0" cellpadding="0">
                                              <tr>
                                                <td align="left" valign="top" style="line-height:2.3em;
    padding: 15px 45px;
">
                                                  <span style="font-weight:600">My Height: <span
                                                      style=" font-size: 16px; font-weight: 400;">{{ studentRemarks[0].height }}
                                                      cms</span><br />
                                                    My Weight: <span
                                                      style=" font-size: 16px; font-weight: 400;">{{ studentRemarks[0].weight }}
                                                      kgs</span></span>
                                                </td>
                                                <td align="left" valign="top"
                                                  style="line-height:2.3em;">
                                                  <span span style="font-weight:600">as on: <span
                                                      style="font-size: 16px; font-weight: 400;">{{ studentRemarks[0].updatedAt }}</span><br />
                                                    as on: <span
                                                      style="font-size: 16px; font-weight: 400;">{{ studentRemarks[0].updatedAt }}</span></span>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td align="left" valign="top" style="line-height:2.3em;
    padding: 15px 45px;
">
                                                  <span style="font-weight:600">Total No. of days
                                                    Present: <span
                                                      style="font-size: 16px; font-weight: 400;">{{ present }}</span><br />
                                                    Total No. of days Absent: <span
                                                      style="font-size: 16px; font-weight: 400;">{{ absent }}</span></span>
                                                </td>
                                              </tr>
                                            </table>
                                          </td>
                                        </tr>

                                      </table>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td align="center" valign="top">
                                      <table style="border-collapse: collapse;
    border-radius: 20px;
    border-style: hidden;
    position: relative;
    margin-top: 24px;
    box-shadow: 0 0 0 1px #5f3892;" width="600" border="0" cellspacing="0" cellpadding="0">
                                        <tr>
                                          <td style="padding: 15px 45px;" align="left" valign="top">
                                            <span style="font-size: 16px;">
                                              <span style="font-weight: 600;">Behaviour
                                                Remarks:</span>
                                              <span style="">
                                                {{ reportData && reportData.gradeTeacherRemark ? reportData.gradeTeacherRemark.behavioralRemark : '' }}</span></span>
                                            <br>
                                            <br>
                                            <span style="font-size: 16px;"><span
                                                style="font-weight: 600;">General Remarks: </span>
                                              <span
                                                style="">{{ reportData && reportData.gradeTeacherRemark ? reportData.gradeTeacherRemark.generalRemark : '' }}</span></span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <img @load="onLoadAll" style="display: inline-block;
    margin-left: -54px;margin-top:-60px; float:left; margin-bottom: 0px;" width="80"
                                              src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardBoy.png"
                                              alt="" />

                                            <img @load="onLoadAll" width="80" style="width: 80px;
    display: inline-block; margin-top:-50px;
    margin-right: -47px; margin-bottom: 0px;
     float:right;" src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardGirl.png"
                                              alt="" />

                                          </td>

                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                  <tr style="top: 24px;
    width: 84%;
    display: inline-block;
    margin-left: 34px;
    ">
                                    <td align="left" valign="middle">
                                      <table width="630" border="0" cellspacing="0" cellpadding="0">
                                        <img @load="onLoadAll" src="" alt="" />
                                        <tr>
                                          <td align="left" valign="middle">
                                            <span style="font-weight:600;">Name of Teacher: <span
                                                style="font-size: 16px; font-weight: 400; ">{{ studentRemarks[0].teacherName }}</span></span>
                                          </td>
                                          <td align="left" valign="middle"
                                            style="padding-left:100px;"><span
                                              style="font-weight:600;">Teacher's Signature:
                                              ______________</span></td>
                                        </tr>
                                        <tr>
                                          <td align="left" valign="middle">&nbsp;</td>
                                        </tr>
                                        <tr>
                                          <td align="left" valign="middle" style="padding-top:20px">
                                            <span style="font-weight:600; ">Date: <span
                                                style="font-size: 16px; font-weight: 400;">{{ dateOfReportPublish }}</span></span>
                                          </td>
                                          <td align="left" valign="middle"
                                            style="padding-top:20px; padding-left:100px "><span
                                              style="font-weight:600;">Parent's Signature:
                                              _______________</span></td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td align="center" valign="top">
                              <p id="page"
                                style="margin-bottom:0; margin-top:20%; margin-bottom:0px;">
                                {{ lastvalue  }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot></tfoot>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <br clear="all" style="page-break-before:always" />
      </v-card>
    </div>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
// import ReportCard from '@/components/Acad/Grade/Setting/reportCompponent'
import { mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
export default {
  // components: { ReportCard },
  name: 'reportPublish',
  props: ['studentAdmissionId'],
  data () {
    return {
      noOfDaysPresent: null,
      noOfDaysPresentPercent: null,
      tableData: [],
      // studentDetails: [],
      publishData: [],
      termDuration: '',
      absent: 0,
      dateOfReportPublish: '',
      present: 0,
      studentCount: [],
      studentPhoto: '',
      classList: [],
      franchiseeID: '',
      academicYearID: '',
      selectedClassID: '',
      selectedSectionID: '',
      selectedTerm: '',
      terms: [],
      scaleList: [],
      search: '',
      sectionList: [],
      heads: [],
      gradeMaps: [],
      gradeSkill: [],
      reportData: null,
      student: null,
      allData: null,
      studentRemarks: [],
      term: null,
      childDiv: '',
      prtHtml: '',
      lastvalue: null,
      prtHtml1: '',
      prtHtml2: '',
      prtHtml3: '',
      prtHtmlEnd: '',
      loadingComponent: null,
      isLoading: false,
      enablePrint: false,
      tempCount: 0,
      tempArr: [],
      // table Description
      headers: [
        {
          text: 'Criteria',
          align: 'center',
          sortable: false,
          value: 'name'
        },
        { text: 'Description', align: 'center', sortable: false, value: 'des' }
      ],
      nameValues: [
        {
          name: 'Emerging',
          des: 'The child is making progress towards meeting few of the learning outcomes addressed during the current reporting period. He/she demonstrates limited achievement in few of the expected areas of knowledge, concepts, skills or attitude. The child makes errors while performing tasks and requires more time, practice and support of the teacher.'
        },
        {
          name: 'Developing',
          des: 'The child is meeting some of the learning outcomes addressed during the current reporting period. He/she demonstrates satisfactory achievement in some of the expected areas of knowledge, concepts, skills or attitudes. The child makes some errors while performing tasks and requires more time and practice.'
        },
        {
          name: 'Mastering',
          des: 'The child is meeting most of the learning outcomes addressed during the current reporting period. He/she demonstrates good achievement and limited mastery in most of the expected areas of knowledge, concepts, skills or attitudes. The child makes very few errors while performing tasks and could improve with practice.'
        },
        {
          name: 'Proficient',
          des: 'The child is meeting all the learning outcomes addressed during the current reporting period. He/she demonstrates exceptional achievement and mastery in all the expected areas of knowledge, concepts, skills or attitudes. The child makes no errors and regularly produces high quality work.'
        }
      ],
      termHeadingIcon: {
        one: 'https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardterm-1.png',
        two: 'https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardterm-2.png',
        three: 'https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/ReportCardterm-3.png'
      },
      // table attendance
      headerAttendance: [
        {
          text: 'name',
          value: 'name',
          align: 'center',
          sortable: false
        },
        { text: 'Present', value: 'details', align: 'center', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    // reportData () {
    //   if (!this.reportData) {
    //     this.enablePrint = false
    //   }
    // },
    franchisee: async function () {
      await this.onFranchiseeChange()
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    },
    selectedClassID: async function () {
      await this.getTerms()
    },
    selectedTerm: async function () {
      this.reportData = null
      this.noOfDaysPresent = null
      this.noOfDaysPresentPercent = null
      this.absent = 0
      this.present = 0
      await this.getData()
      await this.getTerms()
    },
    student: async function () {
      if (this.student.studentClass.id && this.franchiseeID && this.academicYearID) {
        await this.getTerms()
        await this.getPublishDate()
      }
    }
  },
  created: async function () {
    await this.getScales()
    await this.onFranchiseeChange()
    if (this.studentAdmissionId) {
      await this.studentData()
    }
  },
  methods: {
    termIconHandler (academicTermID) {
      let icon = ''
      switch (academicTermID) {
        case 1:
          icon = this.termHeadingIcon.one
          break
        case 2:
          icon = this.termHeadingIcon.two
          break
        case 3:
          icon = this.termHeadingIcon.three
          break
      }
      // console.log(`academicTermID: ${academicTermID} || Icon: ${icon}`)
      return icon
    },
    onLoadAll (e) {
      this.tempArr.push(e)
      let photoLoaded = _.some(this.tempArr, (a) => a === 'studentPhoto')
      this.tempCount++
      if (this.reportData && this.tempCount > 55 && photoLoaded) {
        this.enablePrint = true
        this.tempArr = []
        photoLoaded = false
      }
    },
    printInvoice: async function () {
      // Get HTML to print from element
      this.prtHtml = document.getElementById('printableArea1')
      this.prtHtml1 = document.getElementById('printableArea2')
      // this.prtHtml2 = document.getElementById('printableArea3')
      this.childDiv = document.getElementsByClassName('loopInPrint')
      this.prtHtmlEnd1 = document.getElementById('printableAreaEnd1')
      this.prtHtmlEnd2 = document.getElementById('printableAreaEnd2')

      // this.prtHtmlEnd = document.getElementById('printableAreaEnd').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=1300,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>

    ${this.prtHtml ? this.prtHtml.innerHTML : ''}

 <p style="page-break-after: always;">&nbsp;</p>
<p style="page-break-before: always;">&nbsp;</p>
    ${this.prtHtml1 ? this.prtHtml1.innerHTML : ''}

 <p style="page-break-after: always;">&nbsp;</p>
<p style="page-break-before: always;">&nbsp;</p>
    ${this.prtHtml2 ? this.prtHtml2.innerHTML : ''}


  </body>

  <style>
  @media print {
    .page-break {
        height: 0;
        page-break-before: always;
        margin: 0;
        border-top: none;
    }
    .boy {
          width: 80px;
    position: absolute;
    bottom: -1px;
    left: -54px;
    }
      .report-card .v-data-table table,{
        border-collapse: separate;
        border: solid #b7deed 1px;
        border-radius: 6px;
        -moz-border-radius: 6px;
      }
      .report-card .v-data-table table thead tr:last-child > th {
        border: thin solid rgba(0, 0, 0, .4) !important;
      }
      .report-card .v-data-table table tbody tr td {
        font-weight: 400 !important;
        border: thin solid rgba(0, 0, 0, .4) !important;
      }

        .firstpage-colors-0{
        background-color: rgb(242, 155, 76);
        -webkit-print-color-adjust: exact;
      }
        .firstpage-colors-1{
        background-color: #f7dcbf;
        -webkit-print-color-adjust: exact;
      }

        .firstpage-colors-2{
        background-color: #feeddd;
        -webkit-print-color-adjust: exact;
      }

        .secondpage-colors-0{
        background-color: #01bbc7;
        -webkit-print-color-adjust: exact;
      }



      #demo {
        margin: 20px auto;
        max-width: 960px;
      }
      #demo h1 {
        font-size: 2.4rem;
        line-height: 3.2rem;
        letter-spacing: 0;
        font-weight: 300;
        color: green;
        text-transform: inherit;
        margin-bottom: 1rem;
        text-align: center;
      }

}
        .report-card .v-data-table table,{
          border-collapse: separate;
          border: solid #b7deed 1px;
          border-radius: 6px;
          -moz-border-radius: 6px;
        }
        .report-card .v-data-table table thead tr:last-child > th {
          border: thin solid rgba(0, 0, 0, .4) !important;
        }
        .report-card .v-data-table table tbody tr td {
          font-weight: 400 !important;
          border: thin solid rgba(0, 0, 0, .4) !important;
        }

        body, p, a,
        span, td {
            font-size: 9pt;
            font-family: Arial, Helvetica, sans-serif;
        }

        body {
            margin-left: .8em;
            margin-right: 2em;
        }

        .page {
            height: 1300px;
            padding-top: 5px;
            page-break-after: always;
            font-family: Arial, Helvetica, sans-serif;
            position: relative;
            border-bottom: 1px solid #000;
        }
  </style>


</html>`)
      let l = this.childDiv.length

      for (let i = 0; i < l; i++) {
        WinPrint.document.write(
          `<!DOCTYPE html><html><head> ${stylesHtml}</head></html><body> ${this.childDiv[i].innerHTML}<p style="page-break-after: always;">&nbsp;</p><p style="page-break-before: always;">&nbsp;</p>
 </body><style>
  @media print {
    .page-break {
        height: 0;
        page-break-before: always;
        margin: 0;
        border-top: none;

    }
      .report-card .v-data-table table,{
        border-collapse: separate;
        border: solid #b7deed 1px;
        border-radius: 6px;
        -moz-border-radius: 6px;
      }
      .report-card .v-data-table table thead tr:last-child > th {
        border: thin solid rgba(0, 0, 0, .4) !important;
      }
      .report-card .v-data-table table tbody tr td {
        font-weight: 400 !important;
        border: thin solid rgba(0, 0, 0, .4) !important;
      }

        .firstpage-colors-0{
        background-color: rgb(242, 155, 76);
        -webkit-print-color-adjust: exact;
      }
        .firstpage-colors-1{
        background-color: #f7dcbf;
        -webkit-print-color-adjust: exact;
      }

        .firstpage-colors-2{
        background-color: #feeddd;
        -webkit-print-color-adjust: exact;
      }

        .secondpage-colors-0{
        background-color: #01bbc7;
        -webkit-print-color-adjust: exact;
      }



      #demo {
        margin: 20px auto;
        max-width: 960px;
      }
      #demo h1 {
        font-size: 1.4rem;
        line-height: 1.4rem;
        letter-spacing: 0;
        font-weight: 300;
        color: green;
        text-transform: inherit;
        margin-bottom: 1rem;
        text-align: center;
      }

}
        .report-card .v-data-table table,{
          border-collapse: separate;
          border: solid #b7deed 1px;
          border-radius: 6px;
          -moz-border-radius: 6px;
        }
        .report-card .v-data-table table thead tr:last-child > th {
          border: thin solid rgba(0, 0, 0, .4) !important;
        }
        .report-card .v-data-table table tbody tr td {
          font-weight: 400 !important;
          border: thin solid rgba(0, 0, 0, .4) !important;
        }

        body, p, a,
        span, td {
            font-size: 9pt;
            font-family: Arial, Helvetica, sans-serif;
        }

        body {
            margin-left: .8em;
            margin-right: 2em;
        }

        .page {
            height: 1300px;
            padding-top: 5px;
            page-break-after: always;
            font-family: Arial, Helvetica, sans-serif;
            position: relative;
            border-bottom: 1px solid #000;
        }
  </style>


</html>`
        )
      }

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>

    ${this.prtHtmlEnd1 ? this.prtHtmlEnd1.innerHTML : ''}
  </body>

  <style>
  @media print {
    .page-break  {
        height: 0;
        page-break-before: always;
        page-break-after: always;
        margin: 0;
        border-top: none;
    }
      .report-card .v-data-table table,{
        border-collapse: separate;
        border: solid #b7deed 1px;
        border-radius: 6px;
        -moz-border-radius: 6px;
      }
      .report-card .v-data-table table thead tr:last-child > th {
        border: thin solid rgba(0, 0, 0, .4) !important;
      }
      .report-card .v-data-table table tbody tr td {
        font-weight: 400 !important;
        border: thin solid rgba(0, 0, 0, .4) !important;
      }

        .firstpage-colors-0{
        background-color: rgb(242, 155, 76);
        -webkit-print-color-adjust: exact;
      }
        .firstpage-colors-1{
        background-color: #f7dcbf;
        -webkit-print-color-adjust: exact;
      }

        .firstpage-colors-2{
        background-color: #feeddd;
        -webkit-print-color-adjust: exact;
      }

        .secondpage-colors-0{
        background-color: #01bbc7;
        -webkit-print-color-adjust: exact;
      }



      #demo {
        margin: 20px auto;
        max-width: 960px;
      }
      #demo h1 {
        font-size: 1.4rem;
        line-height: 1.4rem;
        letter-spacing: 0;
        font-weight: 300;
        color: green;
        text-transform: inherit;
        margin-bottom: 1rem;
        text-align: center;
      }

}
        .report-card .v-data-table table,{
          border-collapse: separate;
          border: solid #b7deed 1px;
          border-radius: 6px;
          -moz-border-radius: 6px;
        }
        .report-card .v-data-table table thead tr:last-child > th {
          border: thin solid rgba(0, 0, 0, .4) !important;
        }
        .report-card .v-data-table table tbody tr td {
          font-weight: 400 !important;
          border: thin solid rgba(0, 0, 0, .4) !important;
        }

        body, p, a,
        span, td {
            font-size: 9pt;
            font-family: Arial, Helvetica, sans-serif;
        }

        body {
            margin-left: .8em;
            margin-right: 2em;
        }

        .page {
            height: 1300px;
            padding-top: 5px;
            page-break-after: always;
            font-family: Arial, Helvetica, sans-serif;
            position: relative;
            border-bottom: 1px solid #000;
        }

  </style>


</html>`)

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>

    ${this.prtHtmlEnd2 ? this.prtHtmlEnd2.innerHTML : ''}
  </body>

  <style>
  @media print {
    .page-break   {
        height: 0;
        page-break-before: always;
        margin: 0;
        border-top: none;

    }
      .report-card .v-data-table table,{
        border-collapse: separate;
        border: solid #b7deed 1px;
        border-radius: 6px;
        -moz-border-radius: 6px;
      }
      .report-card .v-data-table table thead tr:last-child > th {
        border: thin solid rgba(0, 0, 0, .4) !important;
      }
      .report-card .v-data-table table tbody tr td {
        font-weight: 400 !important;
        border: thin solid rgba(0, 0, 0, .4) !important;
      }

        .firstpage-colors-0{
        background-color: rgb(242, 155, 76);
        -webkit-print-color-adjust: exact;
      }
        .firstpage-colors-1{
        background-color: #f7dcbf;
        -webkit-print-color-adjust: exact;
      }

        .firstpage-colors-2{
        background-color: #feeddd;
        -webkit-print-color-adjust: exact;
      }

        .secondpage-colors-0{
        background-color: #01bbc7;
        -webkit-print-color-adjust: exact;
      }



      #demo {
        margin: 20px auto;
        max-width: 960px;
      }
      #demo h1 {
        font-size: 2.4rem;
        line-height: 3.2rem;
        letter-spacing: 0;
        font-weight: 300;
        color: green;
        text-transform: inherit;
        margin-bottom: 1rem;
        text-align: center;
      }

}
        .report-card .v-data-table table,{
          border-collapse: separate;
          border: solid #b7deed 1px;
          border-radius: 6px;
          -moz-border-radius: 6px;
        }
        .report-card .v-data-table table thead tr:last-child > th {
          border: thin solid rgba(0, 0, 0, .4) !important;
        }
        .report-card .v-data-table table tbody tr td {
          font-weight: 400 !important;
          border: thin solid rgba(0, 0, 0, .4) !important;
        }

        body, p, a,
        span, td {
            font-size: 9pt;
            font-family: Arial, Helvetica, sans-serif;
        }

        body {
            margin-left: .8em;
            margin-right: 2em;
        }

        .page {
            height: 1300px;
            padding-top: 5px;
            page-break-after: always;
            font-family: Arial, Helvetica, sans-serif;
            position: relative;
            border-bottom: 1px solid #000;
        }
  </style>


</html>`)
      // Open the print window

      WinPrint.document.close()
      WinPrint.focus()
      setTimeout(function () {
        WinPrint.print()
      }, 1000)
      // WinPrint.onfocus = function () {
      //   setTimeout(function () {
      //     WinPrint.close()
      //   }, 500)
      // }
    },
    studentData: async function () {
      try {
        this.isLoading = true
        let data = await http.get(`${constants.API_URL}/api/student/${this.studentAdmissionId}`)
        this.student = data.data
        this.student.studentEnrollment.dateOfBirth = moment(this.student.studentEnrollment.dateOfBirth).format('YYYY-MM-DD')
        this.student.studentEnrollment.dateOfAdmission = moment(this.student.studentEnrollment.dateOfAdmission).format('YYYY-MM-DD')
        this.student.studentEnrollment.gender =
          this.student.studentEnrollment.gender === 'MALE' ? 'Boy' : this.student.studentEnrollment.gender === 'FEMALE' ? 'Girl' : this.student.studentEnrollment.gender
        this.isLoading = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.student) {
          if (this.franchiseeID && this.academicYearID && this.student.studentClass.id) {
            this.getTerms()
          }
        }
        this.inProgress = false
      }
    },
    getTerms: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/grade-module/academic-terms/date/map?classID=${this.student.studentClass.id}&&franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}`
        )
        this.terms = data
        let t = this.terms.map((a) => {
          a.toDate = moment(a.toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.fromDate = moment(a.fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.customName = `${a.academicTerm.name} (${a.fromDate}/${a.toDate})`
          if (a.id === this.selectedTerm) {
            console.log(this.selectedTerm, 'this.selectedTerm', a.id, ' a.id')
            this.termDuration = `${a.fromDate} to ${a.toDate}`
          }

          return a
        })
        this.terms = t
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getData: async function () {
      this.terms.forEach((e) => {
        if (e.id === this.selectedTerm) {
          this.term = e.academicTerm.name
          // console.log(e.fromDate, e.toDate, 'fromto')
          this.getReport(e.fromDate, e.toDate)
        }
      })
      await this.getPublishDate()
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/grade-module/student/report?studentAdmissionsID=${this.studentAdmissionId}&&academicTermsDateMapID=${this.selectedTerm}`)
        if (res.data.length > 0) {
          //   console.log(res.data, 'res.data 1')
          this.reportData = res.data[0]
          this.studentPhoto =
            this.reportData &&
            this.reportData.studentEnrollment &&
            this.reportData.studentEnrollment.enquiry &&
            this.reportData.studentEnrollment.enquiry.enquiryRegistrations[0] &&
            this.reportData.studentEnrollment.enquiry.enquiryRegistrations[0].studentPhotoUrl
              ? this.reportData.studentEnrollment.enquiry.enquiryRegistrations[0].studentPhotoUrl
              : ''
          this.allData = res.data[0]
          let remarks = this.reportData.gradeStudentHealthRemark
          let teacherName = this.reportData.gradeTeacherRemark ? this.reportData.gradeTeacherRemark.user : ''
          this.studentRemarks.push({
            height: remarks ? remarks.height : '',
            weight: remarks ? remarks.weight : '',
            updatedAt: remarks ? moment(remarks.updatedAt, 'YYYY-MM-DD').format('YYYY-MM-DD') : '',
            teacherName: `${teacherName.firstName ? teacherName.firstName : ''} ${teacherName.lastName ? teacherName.lastName : ''}`
          })
          this.gradeMaps = this.reportData.gradeMaps
          // console.log(this.gradeMaps, 'this.gradeMaps')
          let tbdata
          let unqSubSkills = this.gradeMaps.map((a) => a.gradeSubSkillID).filter((a, b, c) => c.indexOf(a) === b)
          tbdata = unqSubSkills.map((a) => {
            return {
              gradeSubSkillID: a,
              parameters: []
            }
          })
          this.gradeMaps.map((a, i) => {
            tbdata.some((b, j) => {
              if (a.gradeSubSkillID === b.gradeSubSkillID) {
                tbdata[j].parameters.push(a)
                return true
              }
            })
          })

          // let gradeSkillID = []
          // tbdata.map(a => {
          //   a.parameters.map(b => {
          //     gradeSkillID.push(b.gradeSkillID)
          //   })
          // })
          // this.gradeSkill = _.uniq(_.map(gradeSkillID))

          tbdata.map((a) => {
            a.parameters.map((b) => {
              b.customScale = this.scaleList
              b.isAdvance = false
              b.isProficient = false
              b.isStandard = false
              b.isEmerging = false
            })
          })

          tbdata.map((a) => {
            a.parameters.map((b) => {
              b.customScale = JSON.parse(JSON.stringify(b.customScale))
              b.customScale.map((c, j) => {
                if (b.gradeScaleID === c.id) {
                  c.isChecked = true
                }
              })
            })
          })

          tbdata.map((a) => {
            a.parameters.map((b) => {
              b.customScale.map((c) => {
                if (c.name === 'Proficient' && c.isChecked) {
                  b.isAdvance = true
                } else if (c.name === 'Mastering' && c.isChecked) {
                  b.isProficient = true
                } else if (c.name === 'Developing' && c.isChecked) {
                  b.isStandard = true
                } else if (c.name === 'Emerging' && c.isChecked) {
                  b.isEmerging = true
                }
              })
            })
          })

          tbdata = _.sortBy(tbdata, ['parameters[0].gradeSkill.position', 'parameters[0].gradeSubSkill.position', 'parameters[0].gradeParameter.position'])
          this.tableData = tbdata
          // console.log('Datas:', tbdata)
          this.lastvalue = this.tableData.length + 4
          this.heads = this.tableData.map((a) => {
            return [
              { text: a.parameters[0].gradeSubSkill.name, sortable: false, value: 'gradeParameter', width: '40%' },
              { text: 'Emerging', sortable: false, value: 'isEmerging' },
              { text: 'Developing', sortable: false, value: 'isStandard' },
              { text: 'Mastering', sortable: false, value: 'isProficient' },
              { text: 'Proficient', sortable: false, value: 'isAdvance' }
            ]
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getPublishDate: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${constants.API_URL}/api/grade-module/report/publish/setting?classID=${this.student.classID}&&franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&academicTermsDateMapID=${this.selectedTerm}`
        )
        this.publishData = _.map(res.data, (item) => {
          item.isReportView = item.gradeReportPublishDate ? item.gradeReportPublishDate.isReportView : false
          item.date = item.gradeReportPublishDate ? moment(item.gradeReportPublishDate.date).format('YYYY-MM-DD') : null
          item.parentViewDate = item.gradeReportPublishDate ? moment(item.gradeReportPublishDate.parentViewDate).format('YYYY-MM-DD') : null
          return item
        })
        this.publishData.forEach((e) => {
          if (e.gradeReportPublishDate) {
            if (this.student.sectionID === e.gradeReportPublishDate.sectionID) {
              this.dateOfReportPublish = moment(e.gradeReportPublishDate.date).format('YYYY-MM-DD')
            }
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error is in getPublishDate', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getReport: async function (fromDate, toDate) {
      try {
        this.isLoading = true
        let url = `${constants.API_URL}/api/attendance/student/count?franchiseeID=${this.franchiseeID}&&studentAdmissionsID=${this.studentAdmissionId}&&isMonth=false&&fromDate=${fromDate}&&toDate=${toDate}`
        let res = await http.get(url)

        if (res.data) {
          // console.log(res.data.attendanceRecords, 'res.data 2')
          this.studentCount = res.data.attendanceRecords
        }
        //  console.log(this.reportData, 'Data####')
        if (this.studentCount) {
          this.studentCount.forEach((e) => {
            this.present = Number(e.present) + this.present
            this.absent = Number(e.absent) + this.absent
            this.noOfDaysPresent = `${this.present} / ${this.studentCount.length}`
            this.noOfDaysPresentPercent = `${((this.present / this.studentCount.length) * 100).toFixed(2)}%`
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error is in getReport', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getScales: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/grade-module/grade-scale`)
        this.scaleList = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style lang="scss">
#demo {
  margin: 20px auto;
  max-width: 960px;
}

#demo h1 {
  font-size: 1.4rem;
  line-height: 1.4rem;
  letter-spacing: 0;

  text-transform: inherit;
  margin-bottom: 1rem;
  text-align: center;
}
#demo1 {
  margin: 20px auto;
  max-width: 960px;
}
#demo1 h1 {
  font-size: 1.4rem;
  line-height: 1.4rem;
  letter-spacing: 0;

  text-transform: inherit;
  margin-bottom: 1rem;
  text-align: center;
}
#page {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  margin-top: 80px;
  background: #bbdefb;
  border: 2px solid none;
  color: #5c6bc0;
  text-align: center;
  font: 28px Arial, sans-serif;
}
table.bordered-table thead tr th:first-child,
table.bordered-table tr td:first-child {
  border-right: 2px solid #5f3892;
}
.border-right {
  border-right: 2px solid #5f3892;
}
table.bordered-table tbody tr td,
table.bordered-table thead tr th {
  padding: 18px;
}
table.bordered-table tbody tr td.first-column {
  vertical-align: top;
}
.bordered-bottom {
  border-bottom: 2px solid #5f3892;
}
.criteriaAndDescription {
  max-width: 700px;
  position: relative;
  left: 0;
  right: 0;
  margin: auto;
}
.v-align-top {
  vertical-align: top !important;
}
@page {
  size: A4;

  margin-top: 10px;
  // margin-left: 12px;
  // margin-bottom: 0px;
}
// @media print {
//   .page #page {
//     margin: 0;
//     border: initial;
//     border-radius: initial;
//     width: initial;
//     min-height: initial;
//     box-shadow: initial;
//     background: initial;
//     page-break-after: always;
//   }
// }

body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  font: 12pt 'Tahoma';
}
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.page {
  position: relative;
  width: 21cm;
  min-height: 29.7cm;
  padding: 0cm;
  margin: 1cm auto;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
.footer {
  background-color: #b8e6fe;
  position: absolute;
  left: 0;
  right: 0;
  width: 63px;
  margin: auto;
  bottom: 15px;
  border-radius: 30px;
  text-align: center;
}
.subpage {
  height: 100%;
  position: absolute;
  //     padding: 1cm;
  //     border: 5px red solid;
  //     height: 237mm;
  //     outline: 2cm #FFEAEA solid;
}
.fill {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.fill img {
  flex-shrink: 0;
  min-width: 100%;
  // min-height: 100%;
}
.reportCardtitle {
  font-size: 30px;
  margin-bottom: 38px;
  text-align: center;
  font-weight: 600;
  font-size: 25px;
  color: #2f2f72;
}

table.bordered-table {
  // border-collapse: separate;
  border-spacing: 0;
  min-width: 350px;
  border: 2px solid #5f3892;
}
table.bordered-table thead tr th {
  background: #b8e6fe;
}
#pageCount {
  position: absolute;
  left: 50%;

  border-radius: 50%;
  width: 36px;
  height: 36px;
  bottom: 0;
  background: white;
  border: 2px solid none;
  color: black;
  font: 28px Arial, sans-serif;
}
@media print {
  #pageCount {
    position: absolute;
    left: 49%;
    bottom: 120px;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    background: white;
    border: 2px solid none;
    color: black;
    font: 28px Arial, sans-serif;
  }
}

// #footer{
//   position: fixed;
//   bottom:0;
//   align-content: center;
// }
</style>
